<span
  class="provider-badge"
  [class.provider-badge--sm]="size() === 'sm'"
  [style.background]="color()"
  [attr.role]="label() ? 'img' : null"
  [attr.aria-label]="label() || null"
  [attr.aria-hidden]="label() ? null : 'true'"
>
  @if (glyph(); as mark) {
    {{ mark }}
  } @else {
    <svg class="provider-badge__logo" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M11.5 11l-7 7c-.3.3-.3.8 0 1.1l7 7c.3.3.8.3 1.1 0L19.6 19c.3-.3.3-.8 0-1.1l-7-7c-.3-.3-.8-.3-1.1.1z" />
      <path
        d="M11.5 4l-7 7c-.3.3-.3.8 0 1.1l7 7c.3.3.8.3 1.1 0L19.6 12c.3-.3.3-.8 0-1.1l-7-7c-.3-.3-.8-.3-1.1.1z"
        fill-opacity="0.7"
      />
    </svg>
  }
</span>
